<template>

    <div class="container">

        <StepGuide :stepCount="1"></StepGuide>

        <div class="body padding">
            <h1 class="padding teal textAlignCenter">Print Options: Product</h1>
            <div class="overflowCheckout containerButtons">
                <span v-for="(product) in products">
                    <el-radio-group v-on:change="selectProduct(product)" v-model="printJob.printJobSpec.fCode">
                        <!--<span class="centerContainer">-->
                        <el-radio-button :label="product.code" :key="product.code" class="example">

                            <div class="productWindow">
                                <img class="productPreviewIcon centerContainer" v-bind:src="product.pictureSmall">
                            </div>
                            <div>
                                <!--<p class="textAlignCenter productText">{{product.code}}</p>-->
                                <p class="textAlignCenter productText paddingTopSmall">{{product.description}}</p>
                            </div>
                        </el-radio-button>
                        <!--</span>-->
                    </el-radio-group>
                </span>

                <div class="padding">
                    <el-button class="centerContainer redButton ravensworthButtons"
                               :disabled="printJob.printJobSpec.fCode === null" v-on:click="next()">Confirm
                    </el-button>
                </div>
                <!--<PrintJobSelections v-bind:printJob="printJob"></PrintJobSelections>-->
            </div>
        </div>

    </div>

</template>

<script>

    import Axios from 'axios';
    import Router from '../router';
    import PrintJobSelections from '@/components/PrintJobSelections.vue';
    import StepGuide from '@/components/StepGuide.vue';
    import {Loading} from 'element-ui';

    export default {
        name: "products",
        components: {
            StepGuide,
            PrintJobSelections
        },
        props: {
            searchParams: {},
            printJob: {},
            source: ''
        },
        data() {
            return {
                uploadPercentage: '',
                products: [],
                productsHolding: [],
                productSelection: '',
                jobReference: ''
            }
        },
        created() {

            let loadingInstance = Loading.service({
                fullscreen: true,
                background: 'white'
            });

            console.log(this.printJob)

            if (window.sessionStorage.getItem('_source') !== 'undefined') {
                if (typeof this.printJob === 'undefined') {
                    this.printJob = JSON.parse(window.sessionStorage.getItem('_printJob'))
                    console.log(this.printJob)
                }

                this.jobReference = window.sessionStorage.getItem('_propertyName')
            }

            const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindProductsAsync`

            const getProducts = {
                "id": 0,
                "fCode": "",
                "stockType": "string",
                "pageWidth": this.printJob.printJobSpec.pageWidth,
                "pageHeight": this.printJob.printJobSpec.pageHeight,
                "actualPageWidth": 0,
                "actualPageHeight": 0,
                "pageOrientation": "string",
                "stockWeight": "string",
                "lamination": "string",
                "pageCount": this.printJob.printJobSpec.pageCount,
                "quantity": 0
            }

            const headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + window.sessionStorage.getItem('_token') // todo quote may need a login or something - get this clarified
                }
            }
            console.log('Setting Products')
            console.log(window.sessionStorage.getItem('_token'))
            console.log(getProducts)
            console.dir(headers)

            Axios.post(url, getProducts, headers)
                .then(response => {
                    this.productsHolding = response.data
                    console.log(response)
                    console.log('length')
                    console.log(this.productsHolding.length)
                    if (this.productsHolding.length === 0) {
                        console.log('LENGTH 0')
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                        Router.push({
                            name: 'error',
                            params: {
                                errorType: 'noproducts',
                                printJob: this.printJob
                            }
                        });
                    } else if (this.productsHolding.length === 1) {
                        console.log('LENGTH 1')

                        const product = this.productsHolding[0]

                        let url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                        console.log(url)

                        const selectProduct = {
                            "printJobSpec": {
                                "fCode": product.code,
                                "name": product.name,
                                "description" : product.description
                            }
                        }

                        Axios.put(url, selectProduct, {
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "application/json",
                                "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                            }
                        })
                            .then(response => {
                                console.log(response)
                                this.printJob = response.data

                                // let urlObject = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id + '?resetJobSpec=true'
                                let urlObject = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id + '?resetJobSpec=true'

                                const emptyJobSpec = {
                                    "printJobSpec": {
                                    }
                                }

                                Axios.put(urlObject, emptyJobSpec, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Accept": "application/json",
                                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                                    }
                                })
                                    .then(response => {
                                        console.log(response)
                                        this.printJob = response.data

                                        this.$nextTick(() => { // Loading should be closed asynchronously
                                            loadingInstance.close();
                                        });
                                        Router.push({
                                            name: 'wizardSelections',
                                            params: {
                                                printJob: this.printJob
                                            }
                                        });

                                    })

                                // RIFAT NOTES: as part of the bugfix to pricing this was moved up into the promise

                                    // this.$nextTick(() => { // Loading should be closed asynchronously
                                    //     loadingInstance.close();
                                    // });
                                    // Router.push({
                                    //     name: 'wizardSelections',
                                    //     params: {
                                    //         printJob: this.printJob
                                    //     }
                                    // });
                            })
                    } else {
                        console.log(this.productsHolding.length)
                        if (this.productsHolding.length > 1) {
                            console.log('moving products')
                            this.products = this.productsHolding
                        }
                        // this.products = this.productsHolding
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    }
                })
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_printJob', JSON.stringify(this.printJob));
        },
        methods: {
            next() {
                Router.push({
                    name: 'wizardSelections',
                    params: {
                        printJob: this.printJob
                    }
                });
            },
            selectProduct(product) {

                console.log(window.sessionStorage.getItem('_token'))

                let selectedProduct = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                console.log(selectedProduct)

                const selectProduct = {
                    "printJobSpec": {
                        "fCode": product.code,
                        "name": product.name,
                        "description" : product.description
                    }
                }
                console.log('SELECT PRODUCT')
                console.log(selectProduct)

                Axios.put(selectedProduct, selectProduct, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.printJob = response.data

                        const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id + '?resetJobSpec=true'


                        const emptyJobSpec = {
                            "printJobSpec": {
                            }
                        }

                        Axios.put(url, emptyJobSpec, {
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "application/json",
                                "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                            }
                        })
                            .then(response => {
                                console.log(response)
                                this.printJob = response.data
                            })



                    })
            }
        }
    };
</script>